import { isInteger } from 'lodash';
import { QueryFormData, QueryObjectFilterClause } from '@superset-ui/core';

export default function samplingExtra(
  formData: QueryFormData,
): QueryObjectFilterClause[] {
  let sampling_rate = formData?.sampling_rate || 1;
  let sampling_column = formData?.sampling_column?.samplingColumn;
  const isDashboadQuery =
    isInteger(formData?.dashboardId) &&
    formData.dashboardId > 0 &&
    formData?.type !== 'NATIVE_FILTER';

  const isNativeFilterQuery = formData?.type === 'NATIVE_FILTER';
  sampling_rate = isNativeFilterQuery ? 0.3 : sampling_rate;
  sampling_column = isNativeFilterQuery
    ? formData?.sampling_column
    : sampling_column;

  if (!isDashboadQuery && sampling_column && sampling_rate < 1) {
    return [
      {
        col: sampling_column,
        op: '<=',
        val: sampling_rate,
      },
    ];
  }

  return [];
}
